export interface ISectionLocation {
    registryId: string;
    subsetId: string;
    pageId: string;
}

export function checkSectionLocation(location: ISectionLocation): boolean {
    return (location.registryId && location.subsetId && location.pageId) != null;
}
